'use client';

import { RoomAudioRenderer } from '@livekit/components-react';
import type { AppConfig } from '@/app-config';
import { SessionProvider } from '@/components/app/session-provider';
import { EmbedViewController } from '@/components/app/embed-view-controller';
import { Toaster } from '@/components/livekit/toaster';

interface AppProps {
  appConfig: AppConfig;
}

export function App({ appConfig }: AppProps) {
  return (
    <SessionProvider appConfig={appConfig} mode="embed">
      <main
        className="min-h-screen w-full flex flex-col items-center font-abc-repro font-normal text-sm text-gray-900 p-8"
        style={{ backgroundColor: 'transparent' }}
      >
        <EmbedViewController />
      </main>
      <RoomAudioRenderer />
      <Toaster />
    </SessionProvider>
  );
}
